import React from 'react';
import './pullQuote.scss';
import pqImg1 from '../../Assets/pqImg1.jpg';

const PullQuoteWImg = () => {
  return (
    <div className="pullQuoteWImg">
      <div className="pullQuoteWImg__photo">
        <img src={pqImg1} alt="man" />
      </div>
      <div className="pullQuoteWImg__text">
        <p>
          “We start collecting data before the seed is even planted [...] and our success depends on
          understanding the data, bringing it together, and building the appropriate infrastructure
          to act on it.”
        </p>
        <p>Francesco Oliveri | Chief Information Officer at Perfection Fresh</p>
      </div>
    </div>
  );
};

export default PullQuoteWImg;
